module.exports = __webpack_public_path__ + "static/caailab-b1acd3905a65c6a0c1235dca029add12.png";